import { StoreModel, AuthenticationModel } from 'src/mst/models';

export const getAuthenticationModel = (store: StoreModel): AuthenticationModel => {
  return store.authentication;
};
